define('payment/handlers/paymentMethodHandlers/eproCreditCardMethodHandler',['jquery', 'payment/handlers/paymentMethodHandlers/creditCardMethodHandler'], function($, creditCardMethodHandler) {
	'use strict';

	function setupFormTemplate(paymentBox) {
		//creditCardMethodHandler.setupFormTemplate(paymentBox);
	}

	return {
		setupFormTemplate: setupFormTemplate
	};
});

